import { seatApplicationWorkflowStatusValueLabels } from './value-labels.js';
export const seatApplicationWorkflowsCube = {
    category: 'Applications',
    description: 'Application review workflows with their steps, status, and default settings.',
    label: 'Application Workflows',
    requiredModule: 'hasTenure',
    measures: {
        'seat_application_workflows.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'seat_application_workflows.description': {
            label: 'Description',
            narrative: true,
            type: 'string',
        },
        'seat_application_workflows.is_default': { label: 'Is Default', type: 'boolean' },
        'seat_application_workflows.name': { label: 'Name', type: 'string' },
        'seat_application_workflows.status': {
            label: 'Status',
            type: 'string',
            valueLabels: seatApplicationWorkflowStatusValueLabels,
        },
        'seat_application_workflows.total_steps': { label: 'Total Steps', type: 'number' },
    },
    timeDimensions: {
        'seat_application_workflows.created_at': { label: 'Created At', type: 'date' },
        'seat_application_workflows.updated_at': { label: 'Updated At', type: 'date' },
    },
};
